module.exports = __webpack_public_path__ + "img/logo-wide-white.ba4e06af.png";